import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionGuidesCategoryPageData } from './api';
import type { PetitionGuidesCategoryPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: PetitionGuidesCategoryPageDataContext,
	Provider: PetitionGuidesCategoryPageDataContextProvider,
	useContext: usePetitionGuidesCategoryPageData,
	useAsyncData: usePetitionGuidesCategoryPageDataFromApi,
	prefetchAsyncData: prefetchPetitionGuidesCategoryPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionGuidesCategoryPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionGuidesCategoryPageData,
	getUniqueId: (slug, page) => `${slug}:${page}`,
	errorHandler: pageDataErrorHandler<PetitionGuidesCategoryPageDataErrorCode>(),
});
